
import { sessionReportSubtitle, sessionReportTitle } from "./SessionReport"
import { FormatArrayComponent, SubFormatArrayComponent } from "./SummaryArraySection";

const MentalSessionSummary = ({ mentalSessionSummaryReportObject, isEdit, handleInputChange }: any) => {
    return (
        <>
            <span
                className="session_report_title"
                style={sessionReportTitle}
            >
                SOAP Note Summary
            </span>
            <ul>
                <li style={sessionReportSubtitle}>
                    Subjective (Patient-Reported Information):
                </li>
                <SubFormatArrayComponent
                    subIndex="sex"
                    keyName="Sex"
                    value={mentalSessionSummaryReportObject.summary_general.sex}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <SubFormatArrayComponent
                    subIndex={"age"}
                    keyName="Age"
                    value={mentalSessionSummaryReportObject.summary_general.age}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <SubFormatArrayComponent
                    subIndex={"chief_complaint"}
                    keyName="Reason for Visit (Chief Complaint)"
                    value={
                        mentalSessionSummaryReportObject.summary_general.chief_complaint
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <SubFormatArrayComponent
                    subIndex={"history_of_present_illness"}
                    keyName="History of Current Issue"
                    value={
                        mentalSessionSummaryReportObject.summary_general.history_of_present_illness
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />

                <SubFormatArrayComponent
                    subIndex={["past_psychiatric_history", "past_psychiatric_medication", "cognitive_history", "cognitive_functioning", "mental_health", "other_mental_health"]}
                    keyName="Mental Health, Psychiatric, and Cognitive History"
                    value={{
                        past_psychiatric_history: mentalSessionSummaryReportObject.summary_general.past_psychiatric_history,
                        past_psychiatric_medication: mentalSessionSummaryReportObject.summary_general.past_psychiatric_medication,
                        cognitive_history: mentalSessionSummaryReportObject.summary_general.cognitive_history,
                        cognitive_functioning: mentalSessionSummaryReportObject.summary_general.cognitive_functioning,
                        mental_health: mentalSessionSummaryReportObject.summary_general.mental_health,
                        other_mental_health: mentalSessionSummaryReportObject.summary_general.other_mental_health
                    }}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />

                <SubFormatArrayComponent
                    subIndex={["child_trauma", "cultural_belief", "family_history_medical"]}
                    keyName={"Family and Childhood History"}
                    value={{
                        child_trauma: mentalSessionSummaryReportObject.summary_general.child_trauma,
                        cultural_belief: mentalSessionSummaryReportObject.summary_general.cultural_belief,
                        family_history_medical:
                            mentalSessionSummaryReportObject.summary_general.family_history_medical,
                    }}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <SubFormatArrayComponent
                    subIndex={["education", "employment"]}
                    keyName={"Education and Employment Status"}
                    value={{
                        education: mentalSessionSummaryReportObject.summary_general.education,
                        employment: mentalSessionSummaryReportObject.summary_general.employment
                    }}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />

                <SubFormatArrayComponent
                    subIndex={
                        ["relationship", "friends", "support_system", "stress_level", "trigger"]
                    }
                    keyName={
                        "Relationship, Social, and Environmental Factors"
                    }
                    value={
                        {
                            relationship: mentalSessionSummaryReportObject.summary_general.relationship, friends: mentalSessionSummaryReportObject.summary_general.friends, support_system: mentalSessionSummaryReportObject.summary_general.support_system, stress_level: mentalSessionSummaryReportObject.summary_general.stress_level, trigger: mentalSessionSummaryReportObject.summary_general.trigger
                        }
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />

                <SubFormatArrayComponent
                    subIndex={["diet_and_nutrition", "sleep_pattern", "physical_activity", "daily_routine", "energy_level", "hobbies_and_interests", "self_care"]}
                    keyName={"Lifestyle and Daily Functioning"}
                    value={{
                        diet_and_nutrition: mentalSessionSummaryReportObject.summary_general.diet_and_nutrition,
                        sleep_pattern: mentalSessionSummaryReportObject.summary_general.sleep_pattern,
                        physical_activity: mentalSessionSummaryReportObject.summary_general.physical_activity,
                        daily_routine: mentalSessionSummaryReportObject.summary_general.daily_routine,
                        energy_level: mentalSessionSummaryReportObject.summary_general.energy_level,
                        hobbies_and_interests: mentalSessionSummaryReportObject.summary_general.hobbies_and_interests,
                        self_care: mentalSessionSummaryReportObject.summary_general.self_care
                    }}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <SubFormatArrayComponent
                    subIndex={["substance", "secondary_substances", "substance_start", "frequency", "administration", "overdose"]}
                    keyName={"Drugs"}
                    value={{
                        substance: mentalSessionSummaryReportObject.summary_sud.substance,
                        secondary_substances: mentalSessionSummaryReportObject.summary_sud.secondary_substances,
                        substance_start: mentalSessionSummaryReportObject.summary_sud.substance_start,
                        frequency: mentalSessionSummaryReportObject.summary_sud.frequency,
                        administration: mentalSessionSummaryReportObject.summary_sud.administration,
                        overdose: mentalSessionSummaryReportObject.summary_sud.overdose
                    }}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <SubFormatArrayComponent
                    subIndex={["suicide_attempt", "suicide_ideation"]}
                    keyName={"Suicide"}
                    value={{
                        suicide_attempt: mentalSessionSummaryReportObject.summary_general.suicide_attempt,
                        suicide_ideation: mentalSessionSummaryReportObject.summary_general.suicide_ideation
                    }}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <SubFormatArrayComponent
                    subIndex={"medical_surgical_history"}
                    keyName="Medical/Surgical History"
                    value={
                        mentalSessionSummaryReportObject.summary_general.past_medical_history
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <SubFormatArrayComponent
                    subIndex={"current_medications"}
                    keyName="Current Medications"
                    value={
                        mentalSessionSummaryReportObject.summary_general.medication_review
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <li style={sessionReportSubtitle}>
                    Objective (Clinical ObservaMons & Test Results):
                </li>

                <SubFormatArrayComponent
                    subIndex={["physical_examination", "framework", "recent_lab_work", "mental_status_examination", "review_of_systems"]}
                    keyName="Examinations and Tests"
                    value={{
                        physical_examination: mentalSessionSummaryReportObject.summary_general.physical_examination,
                        framework: mentalSessionSummaryReportObject.summary_general.framework,
                        recent_lab_work: mentalSessionSummaryReportObject.summary_general.recent_lab_work,
                        mental_status_examination: mentalSessionSummaryReportObject.summary_general.mental_status_examination,
                        review_of_systems: mentalSessionSummaryReportObject.summary_general.review_of_systems
                    }}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />


                <SubFormatArrayComponent
                    subIndex={["liver_problem", "heart_problem", "thyroid_problem", "adrenal_problem", "neurological_problem", "inflammatory_autoimmune_problem", "hormonal_imbalances", "gastrointestinal_problem", "infection", "diabetes_mellitus", "vitamin_deficiency"]}
                    keyName="Medical Problems"
                    value={{
                        liver_problem: mentalSessionSummaryReportObject.summary_general.liver_problem,
                        heart_problem: mentalSessionSummaryReportObject.summary_general.heart_problem,
                        thyroid_problem: mentalSessionSummaryReportObject.summary_general.thyroid_problem,
                        adrenal_problem: mentalSessionSummaryReportObject.summary_general.adrenal_problem,
                        neurological_problem: mentalSessionSummaryReportObject.summary_general.neurological_problem,
                        inflammatory_autoimmune_problem: mentalSessionSummaryReportObject.summary_general.inflammatory_autoimmune_problem,
                        hormonal_imbalances: mentalSessionSummaryReportObject.summary_general.hormonal_imbalances,
                        gastrointestinal_problem: mentalSessionSummaryReportObject.summary_general.gastrointestinal_problem,
                        infection: mentalSessionSummaryReportObject.summary_general.infection,
                        diabetes_mellitus: mentalSessionSummaryReportObject.summary_general.diabetes_mellitus,
                        vitamin_deficiency: mentalSessionSummaryReportObject.summary_general.vitamin_deficiency,
                    }}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <li style={sessionReportSubtitle}>Assesment:</li>
                <SubFormatArrayComponent
                    subIndex={["diagnosis", "secondary_diagnosis"]}
                    keyName="Diagnostic Impression"
                    value={{
                        diagnosis: mentalSessionSummaryReportObject.summary_general.medication_review,
                        secondary_diagnosis: mentalSessionSummaryReportObject.summary_general.secondary_diagnosis,
                    }}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <SubFormatArrayComponent
                    subIndex={"risk_factor_assessment"}
                    keyName="Risk Factor Assessment"
                    value={
                        mentalSessionSummaryReportObject.summary_general.risk_factor_assessment
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <li style={sessionReportSubtitle}>Plan:</li>
                <SubFormatArrayComponent
                    subIndex={"plan"}
                    keyName="Management Plan"
                    value={
                        mentalSessionSummaryReportObject.summary_general.plan
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />

                <SubFormatArrayComponent
                    subIndex={["allergies", "pregnancy", "other", "insurance", "firearm", "safety", "violence", "legal_problem", "reaction"]}
                    keyName="Special Considerations"
                    value={{
                        allergies: mentalSessionSummaryReportObject.summary_general.allergies,
                        pregnancy: mentalSessionSummaryReportObject.summary_general.pregnancy,
                        other: mentalSessionSummaryReportObject.summary_general.other,
                        insurance: mentalSessionSummaryReportObject.summary_general.insurance,
                        firearm: mentalSessionSummaryReportObject.summary_general.firearm,
                        safety: mentalSessionSummaryReportObject.summary_general.safety,
                        violence: mentalSessionSummaryReportObject.summary_general.violence,
                        legal_problem: mentalSessionSummaryReportObject.summary_general.legal_problem,
                        reaction: mentalSessionSummaryReportObject.summary_general.reaction,
                    }}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
            </ul>
            <span
                className="session_report_title"
                style={sessionReportTitle}
            >
                Detailed Summary
            </span>
            <br />
            <span
                className="session_report_title"
                style={sessionReportSubtitle}
            >
                General Information
            </span>
            <ul>
                <FormatArrayComponent
                    subIndex={"visit_scenario"}
                    keyName="Purpose of Visit"
                    value={
                        mentalSessionSummaryReportObject.summary_general.visit_scenario
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <FormatArrayComponent
                    subIndex={"medium"}
                    keyName="Consultation Medium"
                    value={
                        mentalSessionSummaryReportObject.summary_general.medium
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />

                <li style={{ fontWeight: "bold" }}>
                    Demographic Details:
                </li>
                <SubFormatArrayComponent
                    subIndex={"age"}
                    keyName="Age"
                    value={mentalSessionSummaryReportObject.summary_general.age}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <SubFormatArrayComponent
                    subIndex="sex"
                    keyName="Gender"
                    value={mentalSessionSummaryReportObject.summary_general.sex}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <SubFormatArrayComponent
                    subIndex="education"
                    keyName="Education Level"
                    value={mentalSessionSummaryReportObject.summary_general.education}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <SubFormatArrayComponent
                    subIndex="employment"
                    keyName="Employment Status"
                    value={mentalSessionSummaryReportObject.summary_general.employment}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
            </ul>
            <span
                className="session_report_title"
                style={sessionReportSubtitle}
            >
                Presenting Complaints
            </span>
            <ul>

                <FormatArrayComponent
                    subIndex={"chief_complaint"}
                    keyName="Chief Complaint"
                    value={
                        mentalSessionSummaryReportObject.summary_general.chief_complaint
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <FormatArrayComponent
                    subIndex={"history_of_present_illness"}
                    keyName="History of Present Issue"
                    value={
                        mentalSessionSummaryReportObject.summary_general.history_of_present_illness
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <FormatArrayComponent
                    subIndex={"interval_history"}
                    keyName="Changes Since Last Visit"
                    value={
                        mentalSessionSummaryReportObject.summary_general.interval_history
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
            </ul>
            {/* Common End** */}
            <span
                className="session_report_title"
                style={sessionReportSubtitle}
            >
                Mental Health and Psychiatric History
            </span>
            <ul>
                <li style={{ fontWeight: "bold" }}>
                    Current Mental Health Status
                </li>
                <SubFormatArrayComponent
                    subIndex={"mental_health"}
                    keyName="Emotional Well-Being"
                    value={
                        mentalSessionSummaryReportObject.summary_general.mental_health
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <SubFormatArrayComponent
                    subIndex={"cognitive_functioning"}
                    keyName="Cognitive Functioning"
                    value={
                        mentalSessionSummaryReportObject.summary_general.cognitive_functioning
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <SubFormatArrayComponent
                    subIndex={"coping_strategy"}
                    keyName="Coping Strategies"
                    value={mentalSessionSummaryReportObject.summary_sud.coping_strategy}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sud')}
                />

                <li style={{ fontWeight: "bold" }}>
                    Past Psychiatric History
                </li>

                <SubFormatArrayComponent
                    subIndex={"past_psychiatric_history"}
                    keyName="Previous Psychiatric Problems"
                    value={mentalSessionSummaryReportObject.summary_general.past_psychiatric_history}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />

                <SubFormatArrayComponent
                    subIndex={"cognitive_history"}
                    keyName="Cognitive History"
                    value={mentalSessionSummaryReportObject.summary_general.cognitive_history}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <SubFormatArrayComponent
                    subIndex={"past_coping_mechanisms"}
                    keyName="Past Coping Mechanisms"
                    value={mentalSessionSummaryReportObject.summary_general.past_coping_strategy}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />

                <SubFormatArrayComponent
                    subIndex={"gender_issue"}
                    keyName="Gender Identity and Related Issues"
                    value={mentalSessionSummaryReportObject.summary_general.gender_issue}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <li style={{ fontWeight: "bold" }}>
                    Suicide Risk Assessment
                </li>
                <SubFormatArrayComponent
                    subIndex={"suicide_attempt"}
                    keyName="Suicide Attempts"
                    value={mentalSessionSummaryReportObject.summary_general.suicide_attempt}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <SubFormatArrayComponent
                    subIndex={"suicide_ideation"}
                    keyName="Suicide Ideation or Plans"
                    value={mentalSessionSummaryReportObject.summary_general.suicide_ideation}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <FormatArrayComponent
                    subIndex={"past_psychiatric_medication"}
                    keyName="Psychiatric Medication Review"
                    value={mentalSessionSummaryReportObject.summary_general.suicide_ideation}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
            </ul>
            <span
                className="session_report_title"
                style={sessionReportSubtitle}
            >
                Substance Use History
            </span>
            <ul>

                <FormatArrayComponent
                    subIndex={"substance"}
                    keyName="Primary Substance"
                    value={mentalSessionSummaryReportObject.summary_sud.substance}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sud')}
                />
                <FormatArrayComponent
                    subIndex={"secondary_substances"}
                    keyName="Secondary Substances"
                    value={mentalSessionSummaryReportObject.summary_sud.secondary_substances}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sud')}
                />
                <li style={{ fontWeight: "bold" }}>
                    Usage Patterns:
                </li>
                <SubFormatArrayComponent
                    subIndex={"substance_start"}
                    keyName="Substance Use Onset"
                    value={mentalSessionSummaryReportObject.summary_sud.substance_start}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sud')}
                />
                <SubFormatArrayComponent
                    subIndex={"frequency"}
                    keyName="Frequency and Dosage"
                    value={mentalSessionSummaryReportObject.summary_sud.frequency}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sud')}
                />
                <SubFormatArrayComponent
                    subIndex={"administration"}
                    keyName="Method of Administration"
                    value={mentalSessionSummaryReportObject.summary_sud.administration}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sud')}
                />
                <li style={{ fontWeight: "bold" }}>
                    Substance-Related Risks
                </li>
                <SubFormatArrayComponent
                    subIndex={"relapse"}
                    keyName="History of Relapse"
                    value={mentalSessionSummaryReportObject.summary_sud.relapse}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sud')}
                />
                <SubFormatArrayComponent
                    subIndex={"overdose"}
                    keyName="History of Overdose"
                    value={mentalSessionSummaryReportObject.summary_sud.overdose}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sud')}
                />
                <SubFormatArrayComponent
                    subIndex={"withdrawal_symptoms"}
                    keyName="Withdrawal Symptoms"
                    value={mentalSessionSummaryReportObject.summary_sud.withdrawal_symptoms}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sud')}
                />

                <li style={{ fontWeight: "bold" }}>
                    Motivation and Readiness for Change:
                </li>
                <SubFormatArrayComponent
                    subIndex={"motivation"}
                    keyName="Motivation to Quit"
                    value={mentalSessionSummaryReportObject.summary_sud.motivation}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sud')}
                />
                <SubFormatArrayComponent
                    subIndex={"readiness"}
                    keyName="Readiness to Engage in Treatment"
                    value={mentalSessionSummaryReportObject.summary_sud.readiness}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sud')}
                />
            </ul>
            <span
                className="session_report_title"
                style={sessionReportSubtitle}
            >
                Lifestyle and Daily Functioning
            </span>
            <ul>
                <FormatArrayComponent
                    subIndex={"sleep_pattern"}
                    keyName="Sleep Patterns"
                    value={mentalSessionSummaryReportObject.summary_general.sleep_pattern}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <FormatArrayComponent
                    subIndex={"sleep_pattern"}
                    keyName="Physical Activity"
                    value={mentalSessionSummaryReportObject.summary_general.Physical_activity}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sud')}
                />
                <FormatArrayComponent
                    subIndex={"energy_Levels"}
                    keyName="Energy Levels"
                    value={mentalSessionSummaryReportObject.summary_general.energy_Levels}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <FormatArrayComponent
                    subIndex={"daily_routine"}
                    keyName="Daily Routine"
                    value={mentalSessionSummaryReportObject.summary_general.daily_routine}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />


                <FormatArrayComponent
                    subIndex={"diet_and_nutrition"}
                    keyName="Diet and Nutrition"
                    value={mentalSessionSummaryReportObject.summary_general.diet_and_nutrition}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />


                <FormatArrayComponent
                    subIndex={"stress_level"}
                    keyName="Stress Level"
                    value={mentalSessionSummaryReportObject.summary_general.stress_level}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <FormatArrayComponent
                    subIndex={"trigger"}
                    keyName="Triggers for Mental Health Episodes or Substance Use"
                    value={mentalSessionSummaryReportObject.summary_general.trigger}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <FormatArrayComponent
                    subIndex={"hobbies_and_interests"}
                    keyName="Hobbies and Interests"
                    value={mentalSessionSummaryReportObject.summary_general.hobbies_and_interests}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <FormatArrayComponent
                    subIndex={"self_perception_and_confidence"}
                    keyName="Self-Perception and Confidence"
                    value={mentalSessionSummaryReportObject.summary_general.self_perception_and_confidence}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <FormatArrayComponent
                    subIndex={"self_care"}
                    keyName="Self-Care Habits"
                    value={mentalSessionSummaryReportObject.summary_general.self_care}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
            </ul>
            <span
                className="session_report_title"
                style={sessionReportSubtitle}
            >
                Family and Social History
            </span>
            <ul>
                <FormatArrayComponent
                    subIndex={"child_trauma"}
                    keyName="History of Childhood Trauma"
                    value={mentalSessionSummaryReportObject.summary_general.child_trauma}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <FormatArrayComponent
                    subIndex={"relationship"}
                    keyName="Family Relationships"
                    value={mentalSessionSummaryReportObject.summary_general.relationship}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <li style={{ fontWeight: "bold" }}>
                    Social Relationships:
                </li>
                <SubFormatArrayComponent
                    subIndex={"friends"}
                    keyName="Friends and Colleagues"
                    value={mentalSessionSummaryReportObject.summary_general.friends}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <SubFormatArrayComponent
                    subIndex={"support_systems"}
                    keyName="Support Systems"
                    value={mentalSessionSummaryReportObject.summary_general.support_systems}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <SubFormatArrayComponent
                    subIndex={"cultural_belief"}
                    keyName="Cultural and Religious Beliefs"
                    value={mentalSessionSummaryReportObject.summary_general.cultural_belief}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
            </ul>
            <span
                className="session_report_title"
                style={sessionReportSubtitle}
            >
                Safety and Legal Concerns
            </span>
            <ul>
                <li style={{ fontWeight: "bold" }}>
                    Safety Risks:
                </li>
                <SubFormatArrayComponent
                    subIndex={"firearm"}
                    keyName="Access To Firearms"
                    value={mentalSessionSummaryReportObject.summary_general.firearm}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <SubFormatArrayComponent
                    subIndex={"safety"}
                    keyName="Unsafe Living Environment"
                    value={mentalSessionSummaryReportObject.summary_general.safety}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <SubFormatArrayComponent
                    subIndex={"violence"}
                    keyName="History of Violence"
                    value={mentalSessionSummaryReportObject.summary_general.violence}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />

                <FormatArrayComponent
                    subIndex={"legal_problem"}
                    keyName="Legal Issues (ongoing or past)"
                    value={mentalSessionSummaryReportObject.summary_general.legal_problem}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
            </ul>
            <span
                className="session_report_title"
                style={sessionReportSubtitle}
            >
                Medical and Physical Health History
            </span>
            <ul>

                <FormatArrayComponent
                    subIndex={"chronic_pain"}
                    keyName="Chronic Pain History"
                    value={mentalSessionSummaryReportObject.summary_general.chronic_pain}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <li style={{ fontWeight: "bold" }}>
                    Medical Conditions:
                </li>

                <SubFormatArrayComponent
                    subIndex={"liver_problem"}
                    keyName="Liver Issues"
                    value={mentalSessionSummaryReportObject.summary_general.liver_problem}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <SubFormatArrayComponent
                    subIndex={"heart_problem"}
                    keyName="Heart Issues"
                    value={mentalSessionSummaryReportObject.summary_general.heart_problem}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />

                <SubFormatArrayComponent
                    subIndex={"thyroid_problem"}
                    keyName="Thyroid Problems"
                    value={mentalSessionSummaryReportObject.summary_general.thyroid_problem}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <SubFormatArrayComponent
                    subIndex={"adrenal_problem"}
                    keyName="Adrenal Problems"
                    value={mentalSessionSummaryReportObject.summary_general.adrenal_problem}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <SubFormatArrayComponent
                    subIndex={"neurological_problem"}
                    keyName="Neurological Conditions"
                    value={mentalSessionSummaryReportObject.summary_general.neurological_problem}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <SubFormatArrayComponent
                    subIndex={"inflammatory_autoimmune_problem"}
                    keyName="Autoimmune/Inflammatory Disorders"
                    value={mentalSessionSummaryReportObject.summary_general.inflammatory_autoimmune_problem}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />

                <SubFormatArrayComponent
                    subIndex={"infections"}
                    keyName="Infections"
                    value={mentalSessionSummaryReportObject.summary_general.infections}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />

                <SubFormatArrayComponent
                    subIndex={"hormonal_imbalnces"}
                    keyName="Hormonal Imbalances"
                    value={mentalSessionSummaryReportObject.summary_general.hormonal_imbalnces}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <SubFormatArrayComponent
                    subIndex={"gastrointestinal_problem"}
                    keyName="Gastrointestinal Issues"
                    value={mentalSessionSummaryReportObject.summary_general.gastrointestinal_problem}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <SubFormatArrayComponent
                    subIndex={"diabetes_mellitus"}
                    keyName="Diabetes Mellitus"
                    value={mentalSessionSummaryReportObject.summary_general.diabetes_mellitus}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <SubFormatArrayComponent
                    subIndex={"vitamin_deficiency"}
                    keyName="Vitamin Deficiency"
                    value={mentalSessionSummaryReportObject.summary_general.vitamin_deficiency}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <FormatArrayComponent
                    subIndex={"allergies"}
                    keyName="Allergies"
                    value={mentalSessionSummaryReportObject.summary_general.allergies}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <FormatArrayComponent
                    subIndex={"medication_review"}
                    keyName="Medication Review"
                    value={mentalSessionSummaryReportObject.summary_general.medication_review}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <FormatArrayComponent
                    subIndex={"recent_lab_work"}
                    keyName="Recent Lab Results"
                    value={mentalSessionSummaryReportObject.summary_general.recent_lab_work}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
            </ul>
            <span
                className="session_report_title"
                style={sessionReportSubtitle}
            >
                Screening
            </span>
            <ul>
                <FormatArrayComponent
                    subIndex={"framework"}
                    keyName="Psychiatric, Psychological, or Cognitive Tests"
                    value={mentalSessionSummaryReportObject.summary_general.framework}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
            </ul>
            <span
                className="session_report_title"
                style={sessionReportSubtitle}
            >
                Treatment and Follow-Up
            </span>
            <ul>
                <FormatArrayComponent
                    subIndex={"diagnosis"}
                    keyName="Diagnosis"
                    value={mentalSessionSummaryReportObject.summary_general.diagnosis}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <FormatArrayComponent
                    subIndex={"plan"}
                    keyName="Management Plan"
                    value={mentalSessionSummaryReportObject.summary_general.plan}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <li style={{ fontWeight: "bold" }}>
                    Special Considerations:
                </li>

                <SubFormatArrayComponent
                    subIndex={"pregnancy"}
                    keyName="Pregnancy Status"
                    value={mentalSessionSummaryReportObject.summary_general.pregnancy}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <SubFormatArrayComponent
                    subIndex={"secondary_diagnosis"}
                    keyName="Comorbid Conditions"
                    value={mentalSessionSummaryReportObject.summary_general.secondary_diagnosis}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
                <SubFormatArrayComponent
                    subIndex={"insurance"}
                    keyName="Insurance Coverage"
                    value={mentalSessionSummaryReportObject.summary_general.insurance}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
            </ul>
            <span
                className="session_report_title"
                style={sessionReportSubtitle}
            >
                AIDA’s Touch
            </span>
            <ul>
                <SubFormatArrayComponent
                    subIndex={"vocabulary"}
                    keyName="Language and Word Choice"
                    value={mentalSessionSummaryReportObject.summary_general.vocabulary}
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_general')}
                />
            </ul>
        </>
    )
}

export default MentalSessionSummary;